import actions from '@/core/store/pedido/documentos/anexo/actions'
export default {
	actions,
}
